import * as yup from 'yup'
import { MakeRequiredAndNullable } from './utils.js'

export enum POv2LineItemKeys {
  itemNumber = 'itemNumber', // line item number, not to be entered by user
  itemName = 'itemName', // name of the item, often SKU, Unique ID, refernce ID, etc
  description = 'description', // verbose description of the item (human parseable)
  itemQty = 'itemQty', // quantity of the item for order
  unitPrice = 'unitPrice', // price per unit
  lineTotal = 'lineTotal', // total cost per (unitPrice * itemQty), not to be entered by user
}

export const POv2FileDataSchema = yup.object().shape({
  issuer: yup.object().shape({
    attn: yup.string().nullable().optional(),
    companyName: yup.string().nullable().optional(),
    address: yup.string().nullable().optional(),
    phoneNumber: yup.string().nullable().optional(),
    emailAddress: yup.string().nullable().optional(),
  }),
  orderNumber: yup.string().nullable().optional(),
  dateIssued: yup.string().nullable().optional(),
  dateReady: yup.string().nullable().optional(),
  paymentTerms: yup.string().nullable().optional(),
  freightTerms: yup.string().nullable().optional(),
  destination: yup.object().shape({
    attn: yup.string().nullable().optional(),
    companyName: yup.string().nullable().optional(),
    address: yup.string().nullable().optional(),
    phoneNumber: yup.string().nullable().optional(),
    emailAddress: yup.string().nullable().optional(),
  }),
  vendor: yup.object().shape({
    attn: yup.string().nullable().optional(),
    companyName: yup.string().nullable().optional(),
    address: yup.string().nullable().optional(),
    phoneNumber: yup.string().nullable().optional(),
    emailAddress: yup.string().nullable().optional(),
  }),
  items: yup
    .array()
    .of(
      yup.object().shape({
        itemNumber: yup.number().nullable().optional(),
        itemName: yup.string().nullable().optional(),
        description: yup.string().nullable().optional(),
        itemQty: yup.string().nullable().optional(),
        unitPrice: yup.string().nullable().optional(),
        lineTotal: yup.string().nullable().optional(),
      }),
    )
    .required(),
  agreement: yup.string().nullable().optional(),
  instructions: yup.string().nullable().optional(),
})

export type POv2FileData = yup.InferType<typeof POv2FileDataSchema>
type RequiredFileData = MakeRequiredAndNullable<POv2FileData>

export const POv2FileMappings: RequiredFileData = {
  issuer: {
    attn: '406a5c70-dd6e-465b-b49e-e5f16666bf59',
    companyName: '8a0150d7-14c1-45ae-b4c2-a8f5c8eb9aa5',
    address: '8ed1a77b-dd21-49d1-8257-2c44b46872ea',
    phoneNumber: 'b4c971b2-a644-45e4-8b5e-47dd55580d40',
    emailAddress: 'df1a1e89-6d1b-4ceb-9da5-9728ee9ebf13',
  },
  orderNumber: 'd97c4067-83c2-4d36-a824-343245ad9c18',
  paymentTerms: '6a123825-1f60-4e15-bb92-3c45a7a922ec',
  freightTerms: '03142814-a33a-4cef-acd5-732c3b50a155',
  dateIssued: 'fcd88d87-a938-42e7-b3d6-7e52ee1471c9',
  dateReady: '990f7c34-17b5-415c-82d8-84eb755c1b41',
  destination: {
    attn: '243fcb3b-35ca-4f2c-9c96-a61b4ae31124',
    companyName: '09209959-c32a-4a92-88e3-af906b595fa2',
    address: '455d102f-9e10-4796-8bdc-625668608180',
    phoneNumber: 'ec775715-00ff-4f82-a5b1-e7941762e177',
    emailAddress: '214d8f06-45b1-4b8d-9887-a9fe040f0e11',
  },
  vendor: {
    attn: '38528e2b-4c4e-4064-a155-9371ce6e9203',
    companyName: 'da8fb225-1194-4e87-8d28-53f3788673bd',
    address: 'd81d836d-5149-48a6-83fc-c0ca21213794',
    phoneNumber: '99fdab41-57fa-412c-a773-268d37a7895f',
    emailAddress: '21a0a222-97b7-4c1d-9c4c-c3001a81bdeb',
  },
  items: [
    {
      itemNumber: null,
      itemName: '69cfc692-9f03-430b-9d8d-b5b6c1b10504',
      description: '17a17434-3b64-4767-a53f-6e4695eec53c',
      itemQty: '0e53db0f-209f-4a33-b0bf-4d1b607ab3a2',
      unitPrice: '5948a8f4-ee66-45fe-8d68-ba5911c270e5',
      lineTotal: null,
    },
  ],
  agreement: '432fb8c0-15df-4833-8333-6b91c4c0713f',
  instructions: 'ab79cdac-9509-4531-870d-6229b9f9037f',
}
